




































































































































































































































































































































































































































































































































































































































































































import { mapActions, mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import { toPercents } from '@/helpers/decimalsHelpers';

import Tooltip from '@/components/tooltip/Tooltip.vue';
import DurationPicker from '@/components/core/DurationPicker.vue';
import DatePickerWithDialog from '@/components/DatePickerWithDialog.vue';
import SuccessPopupCheck from '@/assets/images/notification/success-popup-check.svg?inline';

import {
  EPromoCampaignType,
  PromoCampaignData,
  ValidationRules
} from '@/api/schema';

import {
  dataInterface,
  ETabKey,
  EFieldTypeKey,
  mapRequestKey,
  daySelectList,
  timeSelectList,
  keysToConvertToPercentage,
  defaultEnabledFields,
  defaultFormData,
  defaultFormsValidValue,
  getTabKeysList,
  getPayloadDataMap,
  getCampaignTypeFieldsConfig,
  getTabsContent
} from '@/views/PromoView/PromoCampaignDialog/PromoCampaignFormConfiguration';

export default {
  name: 'PromoCampaignFormDialog',
  components: {
    Tooltip,
    DurationPicker,
    DatePickerWithDialog,
    SuccessPopupCheck
  },
  props: {
    saving: {
      type: Boolean,
      default: false
    }
  },
  data: (): dataInterface => ({
    ETabKey,
    EFieldTypeKey,
    daySelectList,
    timeSelectList,

    currentTabKey: ETabKey.CAMPAIGN_TYPE,

    formData: { ...defaultFormData },
    formsValid: { ...defaultFormsValidValue },
    enabledFields: { ...defaultEnabledFields },

    showDeadlineDateMenu: false,
    showDurationTimeMenu: false,
    radioGroupValueCustomPeriod: null,
    isShowCongratulations: false
  }),
  watch: {
    'dialog.campaignForm'(isShow: boolean): void {
      this.resetFormsData();

      if (isShow && this.selectedCampaign) {
        this.setFormData(this.selectedCampaign);
        this.currentTabKey = ETabKey.CHECK_ALL;
        return;
      }
      this.currentTabKey = ETabKey.CAMPAIGN_TYPE;
    }
  },
  methods: {
    ...mapActions('Promo', ['showCampaignFormDialog']),
    allowedDates(date: string): boolean {
      return date >= new Date().toISOString().substr(0, 10);
    },
    submitHandler(): void {
      const data = this.getDataToSend();

      this.$emit('submit', data, this.campaignId);
    },
    getDataToSend(): { [key: string]: string | number | boolean } {
      const payloadDataByCampaignType = getPayloadDataMap(
        this.formData,
        this.enabledFields
      );

      return payloadDataByCampaignType[this.formData.campaignType].reduce(
        (resultObj, dataItem) => {
          if (dataItem.dependency) {
            resultObj[dataItem.requestKey] = dataItem.value;
          }

          return resultObj;
        },
        {}
      );
    },
    setFormData(campaignData: PromoCampaignData): void {
      this.setCampaignType(campaignData);
      this.setEnabledFields(campaignData);

      const filteredRequestKeys = {
        ...mapRequestKey,
        ...(this.formData.campaignType === EPromoCampaignType.DEPOSIT
          ? {
              fixedAccrualLimitReward:
                this.enabledFields.accrualFormatType ===
                EFieldTypeKey.FIXED_DEPOSIT
                  ? mapRequestKey.fixedAccrualLimitReward
                  : undefined,
              percentageAccrualLimitReward:
                this.enabledFields.accrualFormatType ===
                EFieldTypeKey.PERCENTAGE_DEPOSIT
                  ? mapRequestKey.percentageAccrualLimitReward
                  : undefined
            }
          : {})
      };

      for (const [formDataKey, campaignDataKey] of Object.entries(
        filteredRequestKeys
      )) {
        if (campaignDataKey && campaignDataKey in campaignData) {
          this.formData[formDataKey] = keysToConvertToPercentage.includes(
            campaignDataKey
          )
            ? toPercents(campaignData[campaignDataKey])
            : campaignData[campaignDataKey];
        }
      }
    },
    setCampaignType(campaignData: PromoCampaignData): void {
      if (campaignData.signUpRule)
        this.formData.campaignType = EPromoCampaignType.REGISTRATION_REWARD;
      else if (campaignData.kycRule)
        this.formData.campaignType = EPromoCampaignType.KYC_REWARD;
      else if (
        campaignData.dailyCashbackReward ||
        campaignData.weeklyCashbackReward
      )
        this.formData.campaignType = EPromoCampaignType.CASHBACK;
      else if (campaignData.accrualCondition)
        this.formData.campaignType = EPromoCampaignType.DEPOSIT;
      else if (campaignData.preSaleCoefficient)
        this.formData.campaignType = EPromoCampaignType.TOKEN_PRE_SALE;
      else this.formData.campaignType = EPromoCampaignType.CUSTOM;
    },
    setEnabledFields(campaignData: PromoCampaignData): void {
      const campaignTypeFieldsConfig = getCampaignTypeFieldsConfig(
        campaignData,
        this.formData.campaignType
      );

      if (campaignTypeFieldsConfig) {
        this.enabledFields = {
          ...defaultEnabledFields,
          ...campaignTypeFieldsConfig
        };
      }
    },
    changeCampaignType(): void {
      this.formData = {
        ...defaultFormData,
        campaignType: this.formData.campaignType
      };
      this.enabledFields = { ...defaultEnabledFields };
      this.resetValidation();
    },
    changeRadioGroupCustomPeriod(key: string): void {
      this.radioGroupCustomPeriod =
        this.radioGroupCustomPeriod === key ? null : key;
      this.enabledFields.customPeriodType = this.radioGroupCustomPeriod;
    },
    resetValidation(): void {
      for (const refName in this.$refs) {
        if (this.$refs[refName]?.resetValidation) {
          this.$refs[refName].resetValidation();
        }
      }
    },
    resetFormsData(): void {
      this.formData = { ...defaultFormData };
      this.enabledFields = { ...defaultEnabledFields };
    },
    nextTab(): void {
      this.currentTabKey = this.tabKeysList[this.currentTabIndex + 1];
    },
    prevTab(): void {
      this.currentTabKey = this.tabKeysList[this.currentTabIndex - 1];
    },
    moveToCheckAllTab(): void {
      this.currentTabKey = this.tabKeysList[this.tabKeysList.length - 1];
    },
    closeAction(): void {
      this.isShowCongratulations = false;
      this.showCampaignFormDialog({ status: false });
      this.$emit('close');
    },
    showCongratulations(): void {
      this.isShowCongratulations = true;
    }
  },
  computed: {
    ...mapState('Auth', ['tokenSymbol']),
    ...mapState('Promo', ['selectedCampaign', 'dialog']),
    campaignId(): number | null {
      return this.selectedCampaign?.id || null;
    },
    isCreateMode(): boolean {
      return this.campaignId === null;
    },
    isViewMode(): boolean {
      return (
        this.campaignId && ['ACTIVE'].includes(this.selectedCampaign?.status)
      );
    },
    isEditMode(): boolean {
      return this.campaignId && !this.isViewMode;
    },
    dialogHeaderText(): string {
      if (this.isViewMode) return 'Campaign Details';
      if (this.isEditMode) return 'Edit Campaign';

      return 'New marketing campaign';
    },
    currentTabIndex(): number {
      return this.tabKeysList.findIndex(
        (tabKey) => tabKey === this.currentTabKey
      );
    },
    tabKeysList(): Array<string> {
      return getTabKeysList(this.formData.campaignType);
    },
    tabsContent(): any {
      return getTabsContent(this.formData, this.enabledFields);
    },
    rules(): ValidationRules {
      const positiveNumberRules = [
        (v) => vr.validNumber(v, 'Value is not valid'),
        vr.required,
        vr.positiveNumber
      ];

      return {
        campaignTypeRadioGroup: [vr.required],
        campaignNameInput: [vr.required, vr.minLength],
        registrationRewardInput: [
          ...positiveNumberRules,
          (v) => vr.lte(v, 100000)
        ],
        rewardProgramCheckboxGroup:
          this.enabledFields.fixedTokensReward ||
          this.enabledFields.extraH2eReward ||
          this.enabledFields.extraP2eReward
            ? []
            : [(v) => !!v],
        tokensRewardInput: this.enabledFields.fixedTokensReward
          ? positiveNumberRules
          : [],
        extraP2eRewardInput: this.enabledFields.extraP2eReward
          ? positiveNumberRules
          : [],
        extraH2eRewardInput: this.enabledFields.extraH2eReward
          ? positiveNumberRules
          : [],
        cashbackTypeRadioGroup: [vr.required],
        dailyCashbackRewardInput:
          this.enabledFields.cashbackType === EFieldTypeKey.DAILY_CASHBACK
            ? [
                ...positiveNumberRules,
                (v) => vr.lte(v, 100),
                (v) => vr.gte(v, 0.01),
                (v) => vr.maxPrecision(v, 2)
              ]
            : [],
        dailyCashbackTimeSelect:
          this.enabledFields.cashbackType === EFieldTypeKey.DAILY_CASHBACK
            ? [vr.required]
            : [],
        dailyLimitReward: this.formData.dailyLimitReward
          ? [
              (v) => vr.validNumber(v, 'Value is not valid'),
              vr.positiveNumber
            ]
          : [],
        weeklyCashbackRewardInput:
          this.enabledFields.cashbackType === EFieldTypeKey.WEEKLY_CASHBACK
            ? [
                ...positiveNumberRules,
                (v) => vr.lte(v, 100),
                (v) => vr.gte(v, 0.01),
                (v) => vr.maxPrecision(v, 2)
              ]
            : [],
        weeklyCashbackDaySelect:
          this.enabledFields.cashbackType === EFieldTypeKey.WEEKLY_CASHBACK
            ? [vr.required]
            : [],
        weeklyCashbackTimeSelect:
          this.enabledFields.cashbackType === EFieldTypeKey.WEEKLY_CASHBACK
            ? [vr.required]
            : [],
        weeklyLimitReward: this.formData.weeklyLimitReward
          ? [
              (v) => vr.validNumber(v, 'Value is not valid'),
              vr.positiveNumber
            ]
          : [],
        accrualFormatTypeRadioGroup: [vr.required],
        fixedAccrualRewardInput:
          this.enabledFields.accrualFormatType === EFieldTypeKey.FIXED_DEPOSIT
            ? positiveNumberRules
            : [],
        fixedAccrualLimitReward: this.formData.fixedAccrualLimitReward
          ? [
              (v) => vr.validNumber(v, 'Value is not valid'),
              vr.positiveNumber
            ]
          : [],
        percentageAccrualDepositInput:
          this.enabledFields.accrualFormatType ===
          EFieldTypeKey.PERCENTAGE_DEPOSIT
            ? [
                ...positiveNumberRules,
                (v) => vr.lte(v, 100),
                (v) => vr.gte(v, 0.01),
                (v) => vr.maxPrecision(v, 2)
              ]
            : [],
        percentageAccrualLimitReward: this.formData
          .percentageAccrualLimitReward
          ? [
              (v) => vr.validNumber(v, 'Value is not valid'),
              vr.positiveNumber
            ]
          : [],
        accrualConditionRadioGroup: [vr.required],
        greaterAccrualConditionInput:
          this.enabledFields.accrualConditionType ===
          EFieldTypeKey.GREATER_THAN_OR_EQUAL
            ? positiveNumberRules
            : [],
        lessAccrualConditionInput:
          this.enabledFields.accrualConditionType ===
          EFieldTypeKey.LESS_THAN_OR_EQUAL_TO
            ? positiveNumberRules
            : [],
        intervalMinAccrualConditionInput:
          this.enabledFields.accrualConditionType ===
          EFieldTypeKey.INTERVAL_FROM_AND_TO
            ? [
                (v) => vr.validNumber(v, 'Value is not valid'),
                vr.required,
                (v) => {
                  const maxValue = this.formData.intervalToAccrualCondition;

                  return maxValue !== null && !isNaN(maxValue)
                    ? vr.lte(v, Number(maxValue))
                    : true;
                }
              ]
            : [],
        intervalMaxAccrualConditionInput:
          this.enabledFields.accrualConditionType ===
          EFieldTypeKey.INTERVAL_FROM_AND_TO
            ? [
                (v) => vr.validNumber(v, 'Value is not valid'),
                vr.required,
                (v) => {
                  const minValue = this.formData.intervalFromAccrualCondition;

                  return minValue !== null && !isNaN(minValue)
                    ? vr.gte(v, Number(minValue))
                    : true;
                }
              ]
            : [],
        deadlineDateSelect:
          this.formData.campaignType === EPromoCampaignType.DEPOSIT
            ? [vr.required]
            : [],
        customDeadlineSelect:
          this.enabledFields.customPeriodType ===
          EFieldTypeKey.CUSTOM_DEADLINE
            ? [vr.required]
            : [],
        customDurationSelect:
          this.enabledFields.customPeriodType ===
          EFieldTypeKey.CUSTOM_DURATION
            ? [vr.required]
            : [],
        maxNumberUsersInput: this.enabledFields.maxUsersCount
          ? positiveNumberRules
          : [],
        preSaleCoefficientInput: [
          ...positiveNumberRules,
          (v) => vr.lte(v, 5000),
          (v) => vr.gte(v, 0.01)
        ]
      };
    },
    isShowNextButton(): boolean {
      const tabsLength = this.tabKeysList.length;
      const arrHideIndex = [tabsLength - 1];

      return !arrHideIndex.includes(this.currentTabIndex) && !this.isEditMode;
    },
    isShowPreviousButton(): boolean {
      const tabsLength = this.tabKeysList.length;
      const arrHideIndex = [0, tabsLength - 1];

      return !arrHideIndex.includes(this.currentTabIndex) && !this.isEditMode;
    },
    isShowOkButton(): boolean {
      const tabsLength = this.tabKeysList.length;

      return this.isEditMode && this.currentTabIndex !== tabsLength - 1;
    },
    isShowSaveButton(): boolean {
      const tabsLength = this.tabKeysList.length;

      return !this.isViewMode && this.currentTabIndex === tabsLength - 1;
    }
  }
};
